import { Component, OnInit } from '@angular/core';
import { NavigationService } from '../../../providers/navigation.service';

@Component({
  selector: 'sm-advertisers',
  templateUrl: './advertisers.component.html',
  styleUrls: ['./advertisers.component.scss']
})
export class AdvertisersComponent implements OnInit {

  constructor(  private _navService: NavigationService) {
    this._navService.hideSidebarAndNav = false;
   }

  ngOnInit(): void {
  }

}
